import React, { useEffect, useState }from "react";
import { Link } from "react-router-dom";
import {
  getReportsAndAnalyticsPermissions,
} from "../../pages/partners/Reporting/utils";
import "../../assets/css/componentSpecificCss/inviteOverview.css";

export const InviteOverview = ({totalInvites, invitesAccepted, listingType}) => {
  const [viewDetails, setViewDetails] = useState(true);
  useEffect(() => {
    const fetchPermissions = async () => {

      try {
        const perms = await getReportsAndAnalyticsPermissions();
        console.log("PERMS", perms);
        const inviteReportPerms = perms.data && perms.data.length > 0 ? perms.data.filter(feature => feature.feature === "Invites Report")[0] : undefined;

        setViewDetails(inviteReportPerms && inviteReportPerms.has_access);
      } catch (error) {
        console.error("Error fetching reports and analytics permissions:", error);
        // Default to hiding details on error
        setViewDetails(false);
      }
    }

    fetchPermissions();
  }, []);
  return (
    <div className="invite-overview-wrapper">
      <div className="invite-overview-content">
        <div style={{
          fontSize: window.innerWidth < 768 ? '0.8rem' : '1rem',
          transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
          transformOrigin: 'left center',
          whiteSpace: 'nowrap',
        }} >
          <span>
            Total Invites:
          </span>
          <span> {totalInvites} </span>
        </div>
        <div style={{
          fontSize: window.innerWidth < 768 ? '0.8rem' : '1rem',
          transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
          transformOrigin: 'left center',
          whiteSpace: 'nowrap'
        }}>
          <span>
            Accepted Invites:
          </span>
          <span>{invitesAccepted}</span>
        </div>
        <div style={{
          fontSize: window.innerWidth < 768 ? '0.8rem' : '1rem',
          transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
          transformOrigin: 'left center',
          whiteSpace: 'nowrap'
        }}>
          <span>
            Invite Conversions:
          </span>
          <span> {totalInvites === 0 ? "N/A" : `${(invitesAccepted / totalInvites * 100).toFixed(1)}%`}</span>
        </div>
       {viewDetails && <Link to={
          {
            pathname: "../reports/invites-report",
            state: {
              listingType: listingType
            }
          }
        } style={{
          fontSize: window.innerWidth < 768 ? '0.8rem' : '1rem',
          transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
          transformOrigin: 'left center',
          whiteSpace: 'nowrap'
        }}>
          Details
        </Link>}
      </div>
    </div>
  );
};